import { create } from 'zustand';

export enum PlayMode {
  Live,
  Playback,
}

interface PlayStore {
  mode: PlayMode;
}

interface PlayAction {
  changeMode: (mode: PlayMode) => void;
}

export const usePlayStore = create<PlayStore & PlayAction>((set) => ({
  mode: PlayMode.Live,
  changeMode: (mode: PlayMode) => set(() => ({ mode })),
}));
